export default __webpack_public_path__ + "static/media/number_of_share.54ec9ddc.svg";